export const MASONRY = {
  DEFAULT_NAMESPACE: "default",
  NODE_TYPE_BULLETED_LIST_ITEM: "bulletedListItem",
  NODE_TYPE_LINEAR_FLOW_STEP: "linearFlowStep",
  NODE_TYPE_LINEAR_FLOW: "linearFlow",
  NODE_TYPE_HERO_BANNER: "heroBanner",
  NODE_TYPE_CARE_LIBRARY_SEARCH_FIELD: "careLibrarySearchField",
  NODE_TYPE_SMALL_CARD: "smallCard",
  NAMESPACE_BRANDING_BANNER: "brandingBanner",
  NAMESPACE_CARE_LIBRARY_SEARCH: "care_library_search",
};
